/* ----- layout defs ----- */
export const LAYOUT_DEFS = {
  SINGLE: 'single',
  TABLE: 'table',
  LIST: 'list',
  SLIDER: 'slider'
}

export const ERROR_DEFS = {
  CONFIG: 'Error in component configuration!',
  SERVER_API: 'Error calling the server API!',
}

export const LANG_DEFS = {
  EN: 'en',
  DE: 'de',
  BG: 'bg'
}

export const BLOG_LABEL_DEFS = {
  PREV: 'prev',
  NEXT: 'next',
  HOME: 'home'
}

// TODO: probably in blogConstants.js?
export const BLOG_LABELS = {
  en: {
    [BLOG_LABEL_DEFS.PREV]: 'Previous Post',
    [BLOG_LABEL_DEFS.NEXT]: 'Next Post',
    [BLOG_LABEL_DEFS.HOME]: 'Back to Blog'
  },
  de: {
    [BLOG_LABEL_DEFS.PREV]: 'Vorheriger Post',
    [BLOG_LABEL_DEFS.NEXT]: 'Nächster Pos',
    [BLOG_LABEL_DEFS.HOME]: 'Zurück zur Blog-Startseite'
  },
  bg: {
    [BLOG_LABEL_DEFS.PREV]: 'Назад',
    [BLOG_LABEL_DEFS.NEXT]: 'Напред',
    [BLOG_LABEL_DEFS.HOME]: 'Към началото'
  }
}

/* ----- functional defs ----- */
export const PIT_DEFS = { pitStripe: 'pit-stripe', pitPaypal: 'pit-paypal' }

export const CONTENT_TYPE_DEFS = {
  COMM_PRODUCT: 'ct-commProduct',
  EVENT: 'ct-event'
}

export const PUSH_HISTORY_STATE_DEFS = {
  QUERY_PARAM: 'query-param',
  URI: 'uri'
}

export const PAYM_METHOD_TYPE_DEFS = Object.freeze({
  PREF_PAYM_PROVIDER: 'pmt-pref-paym-provider',
  INVOICE: 'pmt-invoice',
  COUPON: 'pmt-coupon'
})
